import request from '@/utils/request';

export function getAppConfig() {
  return request({
    url: '/front/appConfig',
    method: 'get',
    silent: true
  });
}
